<template>
  <div class="select">
    <input
      readonly
      type="text"
      :value="value && columns[value - 1].text"
      :placeholder="placeholder"
      class="input"
      @click="visible = true"
    />
    <Popup v-model="visible" position="bottom">
      <Picker show-toolbar value-key="text" :columns="columns" @cancel="visible = false" @confirm="onChange" />
    </Popup>
  </div>
</template>

<script>
import { Picker, Popup } from 'vant';
export default {
  props: ['value', 'placeholder', 'columns'],
  components: { Picker, Popup },
  data() {
    return {
      // columns: [
      //   { id: 1, text: this.$t('appointment.visitors.idcard') },
      //   { id: 2, text: this.$t('appointment.visitors.permit') },
      //   { id: 3, text: this.$t('appointment.visitors.passport') },
      // ],
      visible: false,
      selectValue: '',
    };
  },
  methods: {
    onChange(value) {
      const val = value.id;
      this.$emit('update:value', val, value);
      this.visible = false;
    },
  },

  mounted() {},
  watch: {},
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.input {
  border: none;
  font-size: 30px;
  padding: 6px 0;
  line-height: 34px;
  color: #3d424d;
  width: 100%;

  &::placeholder {
    color: #949aa4;
  }
}
</style>
